
(function () {
  'use strict';

  var PRICE_SORTS = ['price-ascending', 'price-descending'];
  var GRID_ID = 'product-grid';
  var reordering = false;
  var observer = null;

  function currentSort() {
    var fromUrl = new URLSearchParams(window.location.search).get('sort_by');
    if (fromUrl) return fromUrl;
    var select = document.querySelector('.facet-filters__sort');
    return select ? select.value : null;
  }

  function priceOf(li) {
    var v = parseFloat(li.getAttribute('data-sort-price'));
    return isNaN(v) ? 0 : v;
  }

  // Read the active price-filter bounds from the URL. Shopify's price facet uses
  // major currency units (e.g. filter.v.price.lte=100 => 100 zł), while
  // data-sort-price is in the minor unit (grosze), so bounds are kept in zł.
  function priceFilterBounds() {
    var params = new URLSearchParams(window.location.search);
    function num(name) {
      var raw = params.get(name);
      if (raw === null) return null;
      var n = parseFloat(raw.replace(',', '.'));
      return isNaN(n) ? null : n;
    }
    return { min: num('filter.v.price.gte'), max: num('filter.v.price.lte') };
  }

  // Hide products whose displayed price (per m² for m² products) falls outside the
  // active price filter. Shopify filters server-side by variant.price (cena za
  // sztukę), so m² products can slip through the range even though the price shown
  // on the card is outside it — this removes those from view.
  function applyPriceFilter() {
    var grid = document.getElementById(GRID_ID);
    if (!grid) return;

    var bounds = priceFilterBounds();
    var active = bounds.min !== null || bounds.max !== null;
    var products = grid.querySelectorAll('[data-sort-price]');

    for (var i = 0; i < products.length; i++) {
      var li = products[i];
      var out = false;
      if (active) {
        var zl = priceOf(li) / 100; // grosze -> zł, matches the filter's units
        if (bounds.min !== null && zl < bounds.min) out = true;
        if (bounds.max !== null && zl > bounds.max) out = true;
      }
      li.style.display = out ? 'none' : '';
    }
  }

  function isSorted(items, ascending) {
    for (var i = 1; i < items.length; i++) {
      var diff = priceOf(items[i]) - priceOf(items[i - 1]);
      if (ascending ? diff < 0 : diff > 0) return false;
    }
    return true;
  }

  function sortGrid() {
    var grid = document.getElementById(GRID_ID);
    if (!grid) return;

    var sort = currentSort();
    if (PRICE_SORTS.indexOf(sort) === -1) return;

    var ascending = sort === 'price-ascending';
    var children = Array.prototype.slice.call(grid.children);
    // A sortable "product slot" is any node carrying data-sort-price (rendered in
    // Liquid for products only). Everything else — promo tiles, article/page cards
    // in search — keeps its original slot.
    var products = children.filter(function (el) {
      return el.hasAttribute && el.hasAttribute('data-sort-price');
    });
    if (products.length < 2) return;

    // Already in the desired order — nothing to do (avoids needless reflow/loops).
    if (isSorted(products, ascending)) return;

    var sortedProducts = products.slice().sort(function (a, b) {
      return ascending ? priceOf(a) - priceOf(b) : priceOf(b) - priceOf(a);
    });

    // Rebuild the grid: keep every non-product node (e.g. promo tiles) in its
    // original slot, and drop the sorted products into the product slots.
    var fragment = document.createDocumentFragment();
    var idx = 0;
    children.forEach(function (node) {
      if (node.hasAttribute && node.hasAttribute('data-sort-price')) {
        fragment.appendChild(sortedProducts[idx++]);
      } else {
        fragment.appendChild(node);
      }
    });

    reordering = true;
    grid.appendChild(fragment);
    reordering = false;
  }

  function refresh() {
    applyPriceFilter();
    sortGrid();
  }

  function observeGrid() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    if (observer) observer.disconnect();

    observer = new MutationObserver(function () {
      if (reordering) return;
      refresh();
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    refresh();
    observeGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
